export const SEARCH_KMS_REQUEST = "SEARCH_KMS_REQUEST";
export const SEARCH_KMS_SUCCESS = "SEARCH_KMS_SUCCESS";
export const SEARCH_KMS_FAIL = "SEARCH_KMS_FAIL";
export const SET_KMS_SEARCH_LOADING = "SET_KMS_SEARCH_LOADING";
export const CLEAR_KMS_SEARCH_ERROR = "CLEAR_KMS_SEARCH_ERROR";
export const CLEAR_KMS_SEARCH_RESULTS = "CLEAR_KMS_SEARCH_RESULTS";

export const searchKmsRequest = (params) => ({
    type: SEARCH_KMS_REQUEST,
    payload: params,
});

export const searchKmsSuccess = (data) => ({
    type: SEARCH_KMS_SUCCESS,
    payload: data,
});

export const searchKmsFail = (error) => ({
    type: SEARCH_KMS_FAIL,
    error,
});

export const setKmsSearchLoading = (loading) => ({
    type: SET_KMS_SEARCH_LOADING,
    payload: loading,
});

export const clearKmsSearchError = () => ({
    type: CLEAR_KMS_SEARCH_ERROR,
});

export const clearKmsSearchResults = () => ({
    type: CLEAR_KMS_SEARCH_RESULTS,
});
